<section class="home-banner">
    <div class="container h-100">
        <div class="row h-100 align-items-center wow zoomIn" data-wow-delay="0.5">
            <div class="col-xl-6 text-center text-xl-start order-2 order-xl-1">
                <h1 class="text-capitalize text-primary">your gateway to wellness boarding, and grooming</h1>
                <p class="mt-2">Safari is your one
                    stop solution for all your pet care needs.</p>
                <!-- <a class="btn btn-success">Get Started</a> -->
            </div>
            <div class="col-xl-6 order-1 order-xl-2 mb-4 mb-xl-0 text-center">
                <img [src]="'assets/images/home/banner-image.png'" alt="" class="img-fluid banner-img">
            </div>
        </div>
    </div>
</section>
<section class="book-appointment">
    <div class="container">
        <app-boarding-filter></app-boarding-filter>
    </div>
</section>
<section class="pet-plan">
    <img [src]="'assets/images/home/pet-plan-dog.png'" alt=""
        class="position-absolute start-0 bg-dog d-none d-xl-block">
    <div class="container">
        <app-home-plan></app-home-plan>
    </div>
</section>
<section class="client-say">
    <div class="container position-relative">
        <app-testimonials></app-testimonials>
    </div>
</section>
<section class="contact-form">
    <img [src]="'assets/images/home/form-bg-dog.png'" alt=""
        class="position-absolute start-0 end-0 mx-auto bg-dog mt-5">
    <div class="container">
        <app-contact-us></app-contact-us>
    </div>
</section>